"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFuzzySecondsEqual;

function isFuzzySecondsEqual(secondsA, secondsB) {
  return parseFloat(secondsA.toFixed(2)) === parseFloat(secondsB.toFixed(2));
}